module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-13-7322d313aca0a9ddc3c4920e6fe1fc7b.jpg";